import { Injectable } from '@angular/core';
import { Subject, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  events;
  private subject = new Subject();
  constructor() {
    this.events = from(this.subject);
  }

  broadcast(name: string, ...args:any) {
    this.subject?.next({
      name,
      args
    });
  }
}
